import { Color } from '@nect/ui/theme/color';
import React from 'react';

import { IconNotificationsAlertTriangleOutline } from '../icon/auto/notifications-alert-triangle-outline';
import { IconNotificationsCircleCheckedOutline } from '../icon/auto/notifications-circle-checked-outline';
import { IconNotificationsCircleXOutline } from '../icon/auto/notifications-circle-x-outline';
import { IconNotificationsInfoOutline } from '../icon/auto/notifications-info-outline';
import AlertStyled from './alert.styled';

export type AlertType = 'info' | 'success' | 'warning' | 'error';
export interface IAlertProps {
    children: React.ReactNode;
    type: AlertType;
    inline?: boolean;
    hideIcon?: boolean;
    onClick?: React.MouseEventHandler;
    className?: string;
}

type IColorMap = {
    [key in AlertType]: {
        background: Color;
        text: Color;
        // @TODO Add correct type
        icon: any;
    };
};

export const typeMap: IColorMap = {
    info: {
        background: Color.snackInfoPad,
        text: Color.snackInfoBase,
        icon: IconNotificationsInfoOutline,
    },
    success: {
        background: Color.snackSuccessPad,
        text: Color.snackSuccessBase,
        icon: IconNotificationsCircleCheckedOutline,
    },
    error: {
        background: Color.snackErrorPad,
        text: Color.snackErrorBase,
        icon: IconNotificationsCircleXOutline,
    },
    warning: {
        background: Color.snackWarning2Pad,
        text: Color.snackWarning2Base,
        icon: IconNotificationsAlertTriangleOutline,
    },
};

export const Alert = ({
    type,
    inline,
    hideIcon,
    onClick,
    children,
    className,
}: IAlertProps) => {
    const { icon: Icon, text: iconColor } = typeMap[type];

    return (
        <AlertStyled.AlertStyled
            type={type}
            inline={inline}
            onClick={onClick}
            className={className}
        >
            {!hideIcon && <Icon color={iconColor} size={16} />}
            {children}
        </AlertStyled.AlertStyled>
    );
};
